






















































import BatchHandle from './batch-handle';
export default BatchHandle;
